const MOBILE_VIEW_WIDTH_THRES_HOLD_PX = 719

export const isMobile = (): boolean => {
  return document.documentElement.clientWidth <= MOBILE_VIEW_WIDTH_THRES_HOLD_PX
}

export const isDesktop = (): boolean => {
  return !isMobile()
}
